export default [
  {
    name: 'Product',
    prop: 'product_id',
    type: 'autocomplete',
    references: 'admin/products',
    referenceProp: 'name'
  },
  {
    name: 'Category',
    prop: 'category_id',
    type: 'autocomplete',
    references: 'admin/categories',
    customFilters: { type: 'product' },
    referenceProp: 'name'
  }
]
